import { useContext } from "react";
import { ServicesContext } from "../context/index.js";
const useServices = ()=>{
    const services = useContext(ServicesContext);
    if (!services) throw new Error('Services context is empty');
    return services;
};
export { useServices };
